import { useMantineColorScheme } from "@mantine/core"
import { ImageLink } from "../../-components/image-link"

export function InstanceLogoLink() {
  const { colorScheme } = useMantineColorScheme()

  return (
    <ImageLink
      to="/"
      src={`/api/Logo/GetLogo?colorMode=${colorScheme}`}
      style={{ display: "flex" }}
      imageProps={{
        w: "auto",
        mah: 50,
        fit: "contain",
        style: { alignSelf: "start" },
      }}
    />
  )
}
